import apiV2Service from '../api/api-v2.service';
import {RagArticle, RemoteRagArticle} from '../zendesk/zendesk.types';
import {EmbeddingType} from './ragSearch.enums';

const BASE_URL = 'RagSearch';

async function getSimilarArticles({
  prompt,
  embeddingTypes,
  numOfResults = 3,
  similarityThreshold = 0,
  includeLiveDrafts = false,
  includeGlossaryArticle = true,
  abortSignal,
}: {
  prompt: string;
  embeddingTypes: EmbeddingType[];
  numOfResults?: number;
  similarityThreshold?: number;
  includeLiveDrafts?: boolean;
  includeGlossaryArticle?: boolean;
  abortSignal: AbortSignal;
}): Promise<RagArticle[]> {
  const {
    data: {articles},
  } = await apiV2Service.executePostRequest<{articles: RemoteRagArticle[]}>(
    `${BASE_URL}/SearchArticles`,
    {},
    {
      prompt,
      embeddingTypes,
      numOfResults,
      similarityThreshold,
      includeLiveDrafts,
      includeGlossaryArticle,
    },
    {
      abortSignal,
    },
  );

  return articles;
}

const ragSearchApi = {
  getSimilarArticles,
};

export default ragSearchApi;
